import { render, staticRenderFns } from "./MobileRecovery.vue?vue&type=template&id=f7136276&scoped=true"
import script from "./MobileRecovery.vue?vue&type=script&lang=js"
export * from "./MobileRecovery.vue?vue&type=script&lang=js"
import style0 from "./MobileRecovery.vue?vue&type=style&index=0&id=f7136276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7136276",
  null
  
)

export default component.exports